<template>
    <div id="paginate" v-if="paging">
        <div class="wrap-paginate flex flex-center" v-if="showPaging">
            <button :disabled="prevDisabled" class="paginate-btn prev" @click="prevPage">
                <span><i class="ion-chevron-left"></i></span>
                <span v-if="!isMobile">Prev</span>
            </button>
            <ul class="paginate-no flex flex-center">
                <li v-if="more >= 5 ">
                     <button @click="lessPage()">...</button>
                </li>
                <li v-for="index in pagenumber" :key="index" :class="{current : current == index+more}">
                    <button @click="goToPage(index+more)">{{index+more}}</button>
                </li>
                <li v-if="pagenumber == 5 ">
                     <button @click="morePage()">...</button>
                </li>
            </ul>
            <button :disabled="nextDisabled" class="paginate-btn next" @click="nextPage">
                <span v-if="!isMobile">Next</span>
                <span><i class="ion-chevron-right"></i></span>
            </button>
        </div>
    </div>
</template>

<script>
    import  {isMobile}  from 'mobile-device-detect';

    export default {
       props:['paging','endpoint','toptarget'],
       data() {
           return {
               isMobile: isMobile,
               current:1,
               more:0,
               pagenumber:5,
               total_pages:0,
               nextDisabled:false,
               prevDisabled:true,
               showPaging:true,
               target:'#main',
               pageUrl:null,
           }
       },
       created(){
           // this.current = this.paging?.current_page
            // this.total_pages = this.paging.total_page
            // if(this.total_pages < this.pagenumber){
            //     this.pagenumber = this.total_pages;
            // }
            // if(this.total_pages == 0){
            //     this.showPaging = false;
            // }
            // if(this.toptarget){
            //     this.target = this.toptarget;
            // }
       },
       watch: {
            paging: {
                handler(val) {
                    this.total_pages = val.total_page
                    if(this.total_pages < this.pagenumber){
                        this.pagenumber = this.total_pages;
                    }
                    if(this.total_pages == 0){
                        this.showPaging = false;
                    }
                    if(this.toptarget){
                        this.target = this.toptarget;
                    }
                },
                deep: true
            },
         current: function (val) {
           // if(val == 1){
           //   this.prevDisabled == true;
           // }else{
           //   this.prevDisabled == false;
           // }
           // if(val == this?.paging?.total_page){
           //   this.nextDisabled == true;
           // }else{
           //   this.nextDisabled == false;
           // }
         },
       },
       methods:{
            getData(index){
              const url = `${this.paging.end_point}${index}`;
              // console.log(url);
              this.$emit('goToPage', url);
            },
           lessPage(){
             // console.log('les');
            this.prevDisabled = false;
            this.pagenumber = 5
            if(this.paging.total_page > 5){
                this.more -= 5;
                this.total_pages = this.total_pages + this.more;
            }
           },
           morePage(){
             // console.log('more');
             this.prevDisabled = false;
            if(this.paging.total_page > 5){
                this.more += 5;
                this.total_pages = this.paging.total_page - this.more;
                if(this.total_pages < 5){
                    this.pagenumber = this.total_pages
                }
            }
           },
           goToPage(index){
             // console.log('go');
               this.current = index;
               if(this.current > 1){
                   this.prevDisabled = false;
               }
               if(this.current < this.paging.total_page){
                   this.nextDisabled = false;
               }
               this.getData(index);
           },
           nextPage(){
             // console.log('next')
               if(this.current == this.paging.total_page){
                   this.nextDisabled = true;
               }else{
                this.current = this.current + 1;
                // this.scrollToTop();
                // this.$emit('goToPage', this.current);
                this.getData(this.current);
               }
               if(this.current > 1){
                   this.prevDisabled = false;
               }
               if((this.current - this.more) > 5){
                 this.more = this.more +5;
               }
           },
           prevPage(){
             // console.log('prev')
               if(this.current < this.paging.total_page){
                   this.nextDisabled = false;
               }
               if(this.current == 1){
                   this.prevDisabled = true;
               }else{
                this.current = this.current - 1;
                // this.scrollToTop();
                // this.$emit('goToPage', this.current);
                this.getData(this.current);
               }
               if((this.more - this.current) == 0){
                 this.more = this.more - 5;
               }
           },
            scrollToTop() {
            // const c = document.documentElement.scrollTop || document.body.scrollTop;
            // if (c > 0) {
            //    this.$scrollTo(this.target)
            //     window.scrollTo(0, c - c / 8);
            // }
            },
       }
    }
</script>

<style scoped lang="scss">
    #paginate{
        margin: 3em 0;
            .paginate-btn{
                font-size: 14px;
                background-color: transparent;
                border: none;
                box-shadow: none;
                margin: 0 15px;
                color: #E61B33;
                    span{
                        margin: 0 5px;
                        i{
                            font-size: 10px;
                        }
                    }
            }
            .paginate-btn[disabled]{
                color: #dbdbdb;
            }
            .paginate-no{
                margin:0;
                padding:0;
                li{
                    list-style: none;
                    button{
                        display: inline-block;
                        padding: 10px 15px;
                        border: solid 1px #DBDBDB;
                        background-color: #fff;
                        border-radius: 10px;
                        color: #282828;
                        margin: 0 5px;
                        cursor: pointer;
                        &:hover{
                            background-color: #E61B33;
                            color: #fff;
                            border: solid 1px #E61B33;
                        }

                    }
                }
                li.current button{
                    background-color: #E61B33;
                    color: #fff;
                    border: solid 1px #E61B33;
                }
            }
    }
    // ==================================================  MOBILE RESPONSIVE
	@media (max-width: 490px){
        #paginate .paginate-no li a{
            padding: 6px 10px;
            font-size: 11px;
        }
        #paginate .paginate-btn{
            font-size: 12px;
            margin: 0px 0;
        }
        #paginate .paginate-no li button{
            padding: 5px 8px;
            font-size: 10px;
        }
    }
</style>
